import React from "react";

const StyledTitle = ({
	titleWeight = "font-bold",
	subtitleWeight = "",
	titleSize = "text-2xl md:text-3xl",
	titleColor = "text-white",
	centered = false,
	titleText,
	titleText2,
	subtitleText,
	labelText = null,
}) => {
	return (
		<div
			className={`w-full flex flex-col gap-1 ${
				!centered ? "items-start" : "sm:items-center"
			}`}
		>
			<h4 className={`text-lg text-ipxon-magenta ${subtitleWeight}`}>
				{subtitleText}
			</h4>
			<h3
				className={`${titleColor} ${titleSize} ${
					centered && "md:text-center "
				} ${titleWeight}`}
			>
				{titleText}
			</h3>
			<h3 className={`${titleColor} ${titleSize} ${titleWeight}`}>
				{titleText2}
			</h3>
			{labelText && <p className={`${titleColor}`}>{labelText}</p>}
		</div>
	);
};

export default StyledTitle;
